const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.509,
    height: 19.455,
    viewBox: "0 0 12.509 19.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4226",
    d: "M91.4 154.628v13.01a.57.57 0 0 0 .57.57h3.087a.57.57 0 0 0 .52-.336 2.277 2.277 0 0 1 4.155 0 .57.57 0 0 0 .52.336h3.087a.57.57 0 0 0 .57-.57v-13.01z",
    transform: "translate(-91.398 -148.752)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4227",
    d: "M103.337 0h-3.087a.57.57 0 0 0-.52.336 2.282 2.282 0 0 1-2.077 1.345A2.282 2.282 0 0 1 95.575.336a.57.57 0 0 0-.52-.336h-3.087a.57.57 0 0 0-.57.57v4.166h12.509V.57a.57.57 0 0 0-.57-.57z",
    transform: "translate(-91.398)",
    style: {
      fill: "#d9d9d9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservations);
export default __webpack_public_path__ + "static/media/reservations.6a13f91de6475274880bc2ebfdd7236d.svg";
export { ForwardRef as ReactComponent };